export const toDateKey = (value) => {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatTimeInputValue = (value) => {
  if (!value) return '00:00';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '00:00';
  }

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const buildCreatedAtValue = (dateKey, timeValue = '00:00') => {
  if (!dateKey || typeof dateKey !== 'string') {
    return null;
  }

  const [year, month, day] = dateKey.split('-').map(Number);
  const [rawHours = '00', rawMinutes = '00'] = String(timeValue || '00:00').split(':');
  const hours = Number(rawHours);
  const minutes = Number(rawMinutes);

  if (!year || !month || !day || Number.isNaN(hours) || Number.isNaN(minutes)) {
    return null;
  }

  const localDate = new Date(year, month - 1, day, hours, minutes, 0);
  if (Number.isNaN(localDate.getTime())) {
    return null;
  }

  const offsetMinutes = localDate.getTimezoneOffset();
  const offsetSign = offsetMinutes > 0 ? '-' : '+';
  const offsetAbs = Math.abs(offsetMinutes);
  const offsetHours = String(Math.floor(offsetAbs / 60)).padStart(2, '0');
  const offsetMins = String(offsetAbs % 60).padStart(2, '0');

  return `${dateKey}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00${offsetSign}${offsetHours}:${offsetMins}`;
};

const MACRO_FIELD_KEYS = [
  'energy-kcal_100g',
  'proteins_100g',
  'carbohydrates_100g',
  'fat_100g',
  'saturated-fat_100g',
  'trans-fat_100g',
  'monounsaturated-fat_100g',
  'polyunsaturated-fat_100g',
  'cholesterol_100g',
  'sodium_100g',
  'salt_100g',
  'fiber_100g',
  'sugars_100g',
  'added-sugars_100g',
  'starch_100g',
  'calcium_100g',
  'iron_100g',
  'magnesium_100g',
  'zinc_100g',
  'vitamin-c_100g',
];

export const buildInitialMacroValues = (nutrition = {}) => {
  const values = {};
  for (const key of MACRO_FIELD_KEYS) {
    values[key] = nutrition?.[key] || 0;
  }
  return values;
};
